<template>
  <div class="home">
    <template>
      <b-container class="container-rda">
        <b-row>
          <b-col class="content">
            <b-row>
              <b-col>
                <Breadcrumb :breadcrumb="breadcrumb" />
              </b-col>
            </b-row>
            <InternalChangesTabs />

            <b-row class="mb-5">
              <b-col>
                <h2 class="purple bold">Ciclos de matrícula</h2>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col md="4">
                <SelectSimple
                  label="Segmento"
                  v-model="selectedSegment"
                  :options="segmentOptions"
                  :callback="selectSegment"
                />
                <span
                  class="clear-field"
                  v-if="selectedSegment != null"
                  @click="clearSegment"
                  >Limpar filtro</span
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-container fluid>
                  <b-row
                    class="header-list-teacher"
                    v-if="filteredCycleGrades.length > 0 && isRequestSend"
                  >
                    <b-col md="6">
                      <p class="bold">Ciclo</p>
                    </b-col>
                    <b-col>
                      <p class="bold">Segmento</p>
                    </b-col>
                    <b-col>
                      <p class="bold">Turno</p>
                    </b-col>
                    <b-col v-for="calendar in calendars" :key="calendar.id">
                      <p class="bold">{{ calendar.designation }}</p>
                    </b-col>
                  </b-row>
                </b-container>
                <b-container fluid>
                  <b-row
                    align-v="center"
                    class="list-teacher"
                    v-for="cycleGrade in filteredCycleGrades"
                    v-bind:key="cycleGrade.id"
                  >
                    <b-col md="6">
                      <p>{{ cycleGrade.enrollment_description }}</p>
                    </b-col>
                    <b-col>
                      <p>{{ cycleGrade.segment }}</p>
                    </b-col>
                    <b-col>
                      <p class="time-period">{{ cycleGrade.time_period }}</p>
                    </b-col>
                    <b-col
                      class="status"
                      v-for="calendar in calendars"
                      :key="calendar.id"
                    >
                      <b-form-checkbox
                        switch
                        v-model="cycleGrade.calendarStatus[calendar.id]"
                        :disabled="
                          updatingKey === statusKey(cycleGrade, calendar)
                        "
                        @change="updateStatus(cycleGrade, calendar, $event)"
                      ></b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row
                    align-v="center"
                    class="list-teacher"
                    v-if="filteredCycleGrades.length <= 0 && isRequestSend"
                  >
                    <b-col> Nenhum resultado encontrado </b-col>
                  </b-row>
                  <b-row
                    align-v="center"
                    class="list-teacher"
                    v-if="!isRequestSend"
                  >
                    <b-col> Carregando </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>

<script>
import InternalChangesTabs from "@/components/InternalChangesTabs.vue";
import SelectSimple from "@/components/inputs/SelectSimple.vue";
import WaitingListService from "@/services/waitingList.service";
import { WAITING_LIST_POPUP_OPTIONS } from "@/utils/waitingList";

const SEGMENT_LABELS = {
  pititim: "Pititim",
  infantil: "Infantil",
  fundamental: "Fundamental",
  ensinoMedio: "Ensino Médio",
};

export default {
  name: "ciclos-de-matricula",
  components: {
    InternalChangesTabs,
    SelectSimple,
  },
  data() {
    return {
      cycleGrades: [],
      calendars: [],
      selectedSegment: null,
      segmentOptions: Object.entries(SEGMENT_LABELS).map(([id, label]) => ({
        id,
        label,
      })),
      isRequestSend: false,
      updatingKey: null,
      breadcrumb: [
        {
          text: "Secretaria",
          href: "/secretaria",
        },
        {
          text: "Alterações internas",
          active: true,
        },
        {
          text: "Ciclos de matrícula",
          active: true,
        },
      ],
    };
  },
  computed: {
    filteredCycleGrades() {
      if (!this.selectedSegment) {
        return this.cycleGrades;
      }

      return this.cycleGrades.filter(
        (cycleGrade) => cycleGrade.segmentKey === this.selectedSegment.id
      );
    },
  },
  methods: {
    selectSegment(option) {
      this.selectedSegment = option;
    },

    clearSegment() {
      this.selectedSegment = null;
    },

    statusKey(cycleGrade, calendar) {
      return `${cycleGrade.id}-${calendar.id}`;
    },

    getList() {
      Promise.all([
        WaitingListService.getEnrollmentCycles(),
        WaitingListService.getCycleGradeCalendars(),
      ])
        .then(([cyclesResponse, calendarsResponse]) => {
          const cycles = cyclesResponse.data.cycles;
          const { calendars, statuses } = calendarsResponse.data;

          this.calendars = calendars;
          this.cycleGrades = Object.keys(SEGMENT_LABELS).flatMap((key) =>
            (cycles[key] || []).map((cycleGrade) => ({
              ...cycleGrade,
              segment: SEGMENT_LABELS[key],
              segmentKey: key,
              calendarStatus: Object.fromEntries(
                calendars.map((calendar) => {
                  const status = statuses.find(
                    (row) =>
                      row.cycle_grade_id === cycleGrade.id &&
                      row.calendar_id === calendar.id
                  );

                  return [calendar.id, status ? status.active : true];
                })
              ),
            }))
          );
          this.isRequestSend = true;
        })
        .catch((error) => {
          return error;
        });
    },

    async updateStatus(cycleGrade, calendar, active) {
      const result = await this.$swal.fire({
        ...WAITING_LIST_POPUP_OPTIONS,
        title: "Tem certeza?",
        text: active
          ? `Os alunos na lista de espera deste ciclo e turno em ${calendar.designation} serão liberados para continuar a matrícula.`
          : `Novas matrículas deste ciclo e turno em ${calendar.designation} não poderão passar da etapa de dados do aluno.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#68c5b7",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
      });

      if (!result.isConfirmed) {
        cycleGrade.calendarStatus[calendar.id] = !active;
        return;
      }

      this.updatingKey = this.statusKey(cycleGrade, calendar);

      WaitingListService.setCycleGradeActive(cycleGrade.id, calendar.id, active)
        .then((response) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: active
              ? `Status atualizado com sucesso! ${response.data.promoted} aluno(s) liberado(s) da lista de espera.`
              : "Status atualizado com sucesso!",
          });

          return response.data;
        })
        .catch((error) => {
          cycleGrade.calendarStatus[calendar.id] = !active;

          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel atualizar!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        })
        .finally(() => {
          this.updatingKey = null;
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.home {
  height: 100%;
}

.container-rda {
  padding-bottom: 0;
}

.time-period {
  text-transform: capitalize;
}
</style>
